import { createTheme } from '@material-ui/core';
import { base } from './util/Styled';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

const breakpoints = createBreakpoints({});

export const theme = createTheme({
	...base as any,
	overrides: {
		MuiBox: {
			root: {
				textAlign: 'start',
				p: {
					textAlign: 'start'
				},
				h2: {
					textAlign: 'start'
				}
			}
		},
		MuiLink: {
			root: {
				maxWidth: '400px',
				display: 'block',
				whiteSpace: 'nowrap !important'
			}
		},
		MuiDrawer: {
			root: {
				[breakpoints.up(768)]: {
					height: 'unset !important',
					backgroundImage: 'linear-gradient(135deg, #000000, #13650f)',
					backgroundRepeat: 'repeat-x',
					boxShadow: '-6px 0 9px #00000054'
				}
			},
			modal: {
				backgroundImage: 'unset'
			}
		},
		MuiFilledInput: {
			underline: {
				'&&&:before': { 'borderBottom': 'none' }
			},
			root: {
				backgroundColor: 'white', boxShadow: '0px 15px 20px #27313f0c !important', borderRadius: '6px'
			}
		},
		MuiInput: {
			underline: {
				'&&&:before': { 'borderBottom': 'none' }
			},
			root: {
				backgroundColor: 'white', boxShadow: '0px 15px 20px #27313f0c !important', borderRadius: '6px'
			}
		},
		MuiFormHelperText: {
			root: {
				textAlign: 'start'
			}
		},
		MuiInputBase: {
			root: {
				backgroundColor: 'white', boxShadow: '0px 15px 20px #27313f0c !important', borderRadius: '6px'
			}
		},
		MuiPaper: {
			root: {
				backgroundColor: '#F8F9FC',
				elevation0: { boxShadow: '0px 15px 20px #27313f0c !important' },
				elevation1: { boxShadow: '0px 15px 20px #27313f0c !important' },
				elevation2: { boxShadow: '0px 15px 20px #27313f0c !important' },
				elevation3: { boxShadow: '0px 15px 20px #27313f0c !important' }
			},
			elevation0: { boxShadow: '0px 15px 20px #27313f0c !important' },
			elevation1: { boxShadow: '0px 15px 20px #27313f0c !important' },
			elevation2: { boxShadow: '0px 15px 20px #27313f0c !important' },
			elevation3: { boxShadow: '0px 15px 20px #27313f0c !important' }
		},
		MuiAppBar: {
			colorSecondary: { color: '#09111f' }
		},
		MuiTableCell: {
			root: {
				height: '3rem'
			},
			head: {
				paddingTop: '1.5rem !important',
				paddingBottom: '1.5rem !important',
				'border-bottom': '1px solid rgba(224, 224, 224, 1)'
			},
			body: {
				'border-bottom': 'none !important'
			}
		},
		MuiSnackbarContent: {
			root: {
				action: {
					marginRight: 'auto !important',
					marginLeft: '-8px !important'
				}
			},
			action: {
				marginRight: 'auto !important',
				marginLeft: '-8px !important'
			}
		}
	}
});
